<template>
  <div class="page-content">
    <div class="page flex-col">
      <div class="section_1 flex-row">
        <div class="box_1 flex-col">
          <el-carousel class="my-carousel">
            <el-carousel-item>
              <img
                  class="image_2"
                  referrerpolicy="no-referrer"
                  src="./home/img/1.png"
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                  class="image_2"
                  referrerpolicy="no-referrer"
                  src="./home/img/2.png"
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                  class="image_2"
                  referrerpolicy="no-referrer"
                  src="./home/img/3.png"
              />
            </el-carousel-item>
          </el-carousel>

          <div class="box_3 flex-row">
            <span class="text_12">输入展会信息进行搜搜</span>
            <div class="text-wrapper_3 flex-col"><span class="text_13" @click="openRouter1">立即检索</span></div>
          </div>
          <div class="box_4 flex-col">
            <div class="block_1 flex-row">
              <span class="text_14">展会日历</span>
              <div class="text-wrapper_4 flex-col"><span class="text_15">北京</span></div>
              <div class="text-wrapper_5 flex-col"><span class="text_16">12月</span></div>
            </div>

<!--            <div class="block_2 flex-row">
              <div class="group_2 flex-col"></div>
              <div class="group_3 flex-col"></div>
              <div class="group_4 flex-col"></div>
              <div class="group_5 flex-col"></div>
              <div class="group_6 flex-col"></div>
              <div class="group_7 flex-col"></div>
              <div class="text-wrapper_7 flex-col"><span class="text_24">1</span></div>
            </div>
            <div class="block_3 flex-row">
              <div class="text-wrapper_8 flex-col"><span class="text_25">2</span></div>
              <div class="text-wrapper_9 flex-col"><span class="text_26">3</span></div>
              <div class="text-wrapper_10 flex-col"><span class="text_27">4</span></div>
              <div class="text-wrapper_11 flex-col"><span class="text_28">5</span></div>
              <div class="box_5 flex-col">
                <span class="text_29">6</span>
                <div class="group_8 flex-col"></div>
                <div class="text-wrapper_12">
                  <span class="text_30">共</span>
                  <span class="text_31">3</span>
                  <span class="text_32">场展会</span>
                </div>
              </div>
              <div class="box_6 flex-col">
                <span class="text_33">7</span>
                <div class="block_4 flex-col"></div>
                <div class="text-wrapper_13">
                  <span class="text_34">共</span>
                  <span class="text_35">3</span>
                  <span class="text_36">场展会</span>
                </div>
              </div>
              <div class="box_7 flex-col">
                <span class="text_37">8</span>
                <div class="group_9 flex-col"></div>
                <div class="text-wrapper_14">
                  <span class="text_38">共</span>
                  <span class="text_39">3</span>
                  <span class="text_40">场展会</span>
                </div>
              </div>
            </div>
            <div class="block_5 flex-row">
              <div class="text-wrapper_15 flex-col"><span class="text_41">9</span></div>
              <div class="text-wrapper_16">
                <span class="text_42">共</span>
                <span class="text_43">3</span>
                <span class="text_44">场展会</span>
              </div>
              <div class="text-wrapper_17">
                <span class="text_45">共</span>
                <span class="text_46">13</span>
                <span class="text_47">场展会</span>
              </div>
              <div class="text-wrapper_18 flex-col"><span class="text_48">12</span></div>
              <div class="text-wrapper_19 flex-col"><span class="text_49">13</span></div>
              <div class="text-wrapper_20 flex-col"><span class="text_50">14</span></div>
              <div class="text-wrapper_21 flex-col"><span class="text_51">15</span></div>
              <div class="box_8 flex-row">
                <span class="text_52">10</span>
                <div class="group_10 flex-col"></div>
              </div>
              <div class="box_9 flex-row">
                <span class="text_53">11</span>
                <div class="group_11 flex-col"></div>
              </div>
            </div>
            <div class="block_6 flex-row">
              <div class="text-wrapper_22 flex-col"><span class="text_54">16</span></div>
              <div class="text-wrapper_23 flex-col"><span class="text_55">17</span></div>
              <div class="text-wrapper_24 flex-col"><span class="text_56">18</span></div>
              <div class="text-wrapper_25 flex-col"><span class="text_57">19</span></div>
              <div class="text-wrapper_26 flex-col"><span class="text_58">20</span></div>
              <div class="text-wrapper_27 flex-col"><span class="text_59">21</span></div>
              <div class="text-wrapper_28 flex-col"><span class="text_60">22</span></div>
            </div>
            <div class="block_7 flex-row">
              <div class="text-wrapper_29 flex-col"><span class="text_61">23</span></div>
              <div class="text-wrapper_30 flex-col"><span class="text_62">24</span></div>
              <div class="text-wrapper_31 flex-col"><span class="text_63">25</span></div>
              <div class="text-wrapper_32">
                <span class="text_64">共</span>
                <span class="text_65">3</span>
                <span class="text_66">场展会</span>
              </div>
              <div class="text-wrapper_33">
                <span class="text_67">共</span>
                <span class="text_68">3</span>
                <span class="text_69">场展会</span>
              </div>
              <div class="text-wrapper_34 flex-col"><span class="text_70">28</span></div>
              <div class="text-wrapper_35 flex-col"><span class="text_71">29</span></div>
              <div class="group_12 flex-row">
                <span class="text_72">26</span>
                <div class="section_2 flex-col"></div>
              </div>
              <div class="group_13 flex-row">
                <span class="text_73">27</span>
                <div class="group_14 flex-col"></div>
              </div>
            </div>
            <div class="block_8 flex-row">
              <div class="text-wrapper_36 flex-col"><span class="text_74">30</span></div>
              <div class="text-wrapper_37 flex-col"><span class="text_75">31</span></div>
              <div class="box_10 flex-col"></div>
              <div class="box_11 flex-col"></div>
              <div class="box_12 flex-col"></div>
              <div class="box_13 flex-col"></div>
              <div class="box_14 flex-col"></div>
            </div>-->
            <div class="calendar">
              <div class="text-wrapper_6 flex-row">
                <span class="text-week" v-for="w in weeks" :key="w">{{ w }}</span>
              </div>

              <div class="days">
                <div
                    class="day"
                    v-for="(item, index) in calendarList"
                    :key="index"
                    :class="{gray: !item.isCurrentMonth,active: item.isCurrentMonth && item.expoCount}"
                >
                  <span class="text-num-active" v-if="item.expoCount">{{ item.date }}</span>
                  <span class="text-num" v-else>{{ item.date }}</span>

                  <div v-if="item.expoCount" class="expo">
                    共 <span class="count-num" @click="openRouter2(item.date)">{{ item.expoCount }}</span> 场展会
                    <i class="dot"></i>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="text-wrapper_38 flex-row justify-between">
            <span class="text_76">展会推荐</span>
            <span class="text_77" @click="openRouter1">查看详情&nbsp;&gt;</span>
          </div>
          <div class="box_15 flex-row">
            <div class="box_16 flex-col">
              <div class="image-text_1 flex-col justify-between">
                <img
                    class="image_3"
                    referrerpolicy="no-referrer"
                    src="./home/img/FigmaDDSSlicePNG0cbf549e94b2ce81c5de6cfdbd3b2fd1.png"
                />
                <div class="text-group_1 flex-col justify-between">
                  <span class="text_78">2025年亚洲冷链物流展</span>
                  <span class="text_79">11.20-22·深圳会展中心</span>
                  <span class="text_80">+156人关注</span>
                </div>
              </div>
              <div class="text-wrapper_39 flex-col"><span class="text_81" @click="openRouter3">查看</span></div>
            </div>
            <div class="box_17 flex-col">
              <div class="image-text_2 flex-col justify-between">
                <img
                    class="image_4"
                    referrerpolicy="no-referrer"
                    src="./home/img/rqdh.png"
                />
                <div class="text-group_2 flex-col justify-between">
                  <span class="text_78">第29届世界燃气大会(WGC2025)</span>
                  <span class="text_79">2025年5月19日-2025年5月23日·国际会议中心</span>
                  <span class="text_84">+156人关注</span>
                </div>
              </div>
              <div class="text-wrapper_40 flex-col"><span class="text_85"  @click="openRouter">查看</span></div>
            </div>
            <div class="box_18 flex-col">
              <div class="image-text_3 flex-col justify-between">
                <img
                    class="image_5"
                    referrerpolicy="no-referrer"
                    src="./home/img/FigmaDDSSlicePNG105e23c11c46ed201f2ff2ad2acb4ade.png"
                />
                <div class="text-group_3 flex-col justify-between">
                  <span class="text_86">2025年亚洲冷链物流展</span>
                  <span class="text_87">11.20-22·深圳会展中心</span>
                  <span class="text_88">+156人关注</span>
                </div>
              </div>
              <div class="text-wrapper_41 flex-col"><span class="text_89">查看</span></div>
            </div>
          </div>
        </div>
        <div class="box_19 flex-col">
          <div class="block_9 flex-row justify-between">
            <div class="text-wrapper_42 flex-col justify-between">
              <span class="text_90">直链</span>
              <span class="paragraph_1">
                <a class="a-no-text" href="https://www.bcjt.com.cn/" target="_blank">北辰集团</a>
                <br />
<!--                北辰实业-->
                <a class="a-no-text" href="https://www.shouhuigroup.com/" target="_blank">首都会展</a>
                <br />
<!--                国家会议中心-->
              </span>
            </div>
            <div class="text-wrapper_43 flex-col justify-between">
              <span class="text_91">联系我们</span>
              <span class="paragraph_2">
                首都会展(集团)有限公司
                <br />
                地址:北京市朝阳区天辰东路7号国家会议中心
                <br />
                一期北区写字楼(E5门)4层
                <br />
              </span>
            </div>
            <div class="group_15 flex-col justify-between">
              <span class="text_92">订阅</span>
              <div class="group_16 flex-row justify-end">
                <span class="text_93">您的邮箱</span>
                <div class="text-wrapper_44 flex-col"><span class="text_94">订阅</span></div>
              </div>
            </div>
            <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./home/img/FigmaDDSSlicePNGe2660261ad57f4fe2e4904280742f165.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'noHome',
  data() {
    return {
      year: 2025,
      month: 12,
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      expoMap: {
        12: 4,
        13: 4,
        14: 4,
        15: 1,
        27: 1,
        28: 1,
        29: 1,
      },
      calendarList: [],
      constants: {}
    };
  },
  mounted() {
    this.generateCalendar()
  },
  methods: {
    openRouter(){
      const { href } = this.$router.resolve({
        path: 'zhanhui/details',
        query:{id: 'a-187171'}
      });
      window.open(href, '_blank', 'noopener');
    },
    openRouter1(){
      const { href } = this.$router.resolve({
        path: '/zhanhui/list',
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
    openRouter2(date){
      const { href } = this.$router.resolve({
        path: '/zhanhui/list',
        query:{province: '北京',area: '华北',startDate: '2025-12-'+date, endDate: '2025-12-'+date}
      });
      window.open(href, '_blank', 'noopener');
    },
    openRouter3(){
      const { href } = this.$router.resolve({
        path: '/zhanhui/details-d',
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
    generateCalendar() {
      const list = []

      const firstDay = new Date(this.year, this.month - 1, 1).getDay()
      const daysInMonth = new Date(this.year, this.month, 0).getDate()
      const prevMonthDays = firstDay === 0 ? 6 : firstDay - 1

      // 上个月补位
      const prevMonthTotal = new Date(this.year, this.month - 1, 0).getDate()
      for (let i = prevMonthDays; i > 0; i--) {
        list.push({
          date: prevMonthTotal - i + 1,
          isCurrentMonth: false
        })
      }

      // 本月
      for (let i = 1; i <= daysInMonth; i++) {
        list.push({
          date: i,
          isCurrentMonth: true,
          expoCount: this.expoMap[i] || 0
        })
      }

      // 下个月补齐 42 个
      let nextDay = 1
      while (list.length < 42) {
        list.push({
          date: nextDay++,
          isCurrentMonth: false
        })
      }

      this.calendarList = list
    }
  }
};
</script>
<style scoped lang="css" src="./home/index.css" />
<style scoped lang="css" src="./home/common.css" />
<style scoped>
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px 0px;
  justify-content: center;
  align-items: center;
  justify-items: center;
  padding: 0px 20px;
}

.text_color_1 {
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
  font-family: PingFang SC-Regular;
  text-align: left;
  line-height: 24px;
  margin: 4px 0 0 8px;
}
.text-num{
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
  font-family: PingFang SC-Regular;
  font-weight: NaN;
  text-align: left;
  line-height: 24px;
  margin: 4px 0 0 8px;
}

.text-num-active{
  overflow-wrap: break-word;
  color: rgba(38, 99, 235, 1);
  font-size: 12px;
  font-family: PingFang SC-Regular;
  font-weight: NaN;
  text-align: left;
  line-height: 24px;
  margin: 4px 0 0 8px;
}
.count-num{
  overflow-wrap: break-word;
  color: rgba(23, 132, 252, 1);
  font-size: 24px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  cursor: pointer;
}

.day {
  width: 166px;
  border-radius: 8px;
  border: 1px solid #eee;
  height: 64px;
  padding: 8px;
}

.gray {
  border-radius: 8px;
  background: #f5f5f5;
  color: #bbb;
}

.active {
  background-color: rgba(97, 166, 251, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(97, 166, 251, 1);
}

.dot {
  width: 5px;
  height: 5px;
  background: red;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  top: -8px;
  right: 0px;
}
.text-week{
  width: 175px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(75, 85, 99, 1);
  font-size: 12px;
  font-family: PingFang SC-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 24px;
}
.expo{
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 22px;
  position: relative;
  top: -8px;
}
</style>

